import { Component, OnInit } from '@angular/core';
import { QuizAnswerBaseComponent } from '../base/quiz-answer-base.component';
import { DwLookupInfo } from '@devwareapps/devware-cap';
import { QuestionAnswerReviews } from '../../../models/question-answer-review.model';
import { QuizUtilService } from '../../../services/quiz-util.service';

@Component({
  selector: 'app-quiz-answer-true-false',
  template: `
  <label *ngFor="let option of options; let i = index" class="quiz-option"
         [class.is-selected]="!reviewAnswers && selectedOption === option.value"
         [class.is-correct]="(reviewAnswers || testMode) && correctOptionValue === option.value"
         [class.is-incorrect]="(reviewAnswers || testMode) && correctOptionValue !== option.value && selectedOption === option.value"
         [class.is-disabled]="reviewAnswers">
    <input type="radio" class="quiz-option__input" name="answer"
           [disabled]="reviewAnswers"
           [ngModel]="selectedOption"
           [value]="option.value"
           (ngModelChange)="setAnswer(option)" />
    <span class="quiz-option__chip" aria-hidden="true">{{letterFor(i)}}</span>
    <span class="quiz-option__text">{{option.display}}</span>

    <span *ngIf="answerReviews[i] && (reviewAnswers || testMode)" class="quiz-option__review">
      <i class="quiz-option__review-icon" [ngClass]="answerReviews[i].iconClass" aria-hidden="true"></i>
      <span class="quiz-option__review-note">{{answerReviews[i].textNote}}</span>
    </span>
  </label>
  `
})
export class QuizAnswerTrueFalseComponent extends QuizAnswerBaseComponent {
  options: DwRadioItem[] = [];
  answerReviews: QuestionAnswerReviews = {};

  selectedOption: any;
  correctOptionValue: string;

  constructor(private quizUtilService: QuizUtilService) {
    super();
  }

  ngOnInit(): void {
  }

  setAnswer(option: DwRadioItem) {

    this.selectedOption = option.value;
    this.questionAnswerValue.trueFalseAnswer = option.value == 'true';

    this.setAnswerValue(this.questionAnswerValue, true);
  }

  /** Override base A/B/C — true-false uses T / F chips. */
  letterFor(i: number): string {
    return i === 0 ? 'T' : 'F';
  }

  setupAnswer() {
    this.correctOptionValue = this.questionLink?.Question?.CorrectAnswer?.toLowerCase();
    this.options = [
      {
        value: 'true',
        display: 'True'
      },
      {
        value: 'false',
        display: 'False'
      }
    ];

    if (this.questionAnswerValue.trueFalseAnswer == true || this.questionAnswerValue.trueFalseAnswer == false) {
      this.selectedOption = this.questionAnswerValue?.trueFalseAnswer ? 'true' : 'false';
    }
    
    if (this.reviewAnswers) {
      this.answerReviews = this.quizUtilService.getAnswerReviews(this.questionLink, this.questionResult, this.questionAnswerValue);
    }
  }

}


export interface DwRadioItem {
  display: string;
  value: any;
}
